'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var types = require('@brandfolder/types');

const isVideoPreviewType = (contentPreviewType)=>[
        types.ContentPreviewType.VideoMux,
        types.ContentPreviewType.VideoOther,
        types.ContentPreviewType.VideoProcessing
    ].includes(contentPreviewType);

exports.isVideoPreviewType = isVideoPreviewType;
//# sourceMappingURL=preview-type.js.map
